import { Layout } from '@/features/layout/types'
import { PrintJobType } from '@/features/print/constants'
import { usePrintDocument } from '@/features/print/hooks/usePrintDocument'
import CompactShiftCloseoutHistoryRow from '@/features/shiftCloseouts/components/CreateShiftCloseoutPrompt/parts/ShiftCloseoutHistory/parts/ShiftCloseoutHistoryRow/parts/CompactShiftCloseoutHistoryRow'
import ExtendedShiftCloseoutHistoryRow from '@/features/shiftCloseouts/components/CreateShiftCloseoutPrompt/parts/ShiftCloseoutHistory/parts/ShiftCloseoutHistoryRow/parts/ExtendedShiftCloseoutHistoryRow'
import { ShiftCloseoutHistoryItem } from '@/features/shiftCloseouts/types'
import { FC, useCallback } from 'react'

interface ShiftCloseoutHistoryRowProps {
    item: ShiftCloseoutHistoryItem
    layout: Layout
}

const ShiftCloseoutHistoryRow: FC<ShiftCloseoutHistoryRowProps> = ({ item, layout }) => {
    const { print, printing } = usePrintDocument()
    const handleReprint = useCallback(() => {
        void print({ printType: PrintJobType.ShiftCloseout, shiftCloseoutUuid: item.uuid })
    }, [item.uuid, print])

    if (layout === 'compact') {
        return (
            <CompactShiftCloseoutHistoryRow
                item={item}
                onReprint={handleReprint}
                printing={printing}
            />
        )
    }

    return (
        <ExtendedShiftCloseoutHistoryRow
            item={item}
            onReprint={handleReprint}
            printing={printing}
        />
    )
}

export default ShiftCloseoutHistoryRow
